import type { ReactNode } from "react";

import type { SafeInputHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import { useRadioButtonGroupContext } from "../RadioButtonGroupContext";

import styles from "./RadioButton.module.scss";

export type RadioButtonProps = {
  label: ReactNode;
  value: string;
  name?: string;
  disabled?: boolean;
  isError?: boolean;
} & Omit<SafeInputHtmlAttributes, "type" | "value" | "children" | "className">;

export const RadioButton = ({ label, value, name, disabled = false, isError = false, ...rest }: RadioButtonProps) => {
  const { isError: groupIsError, groupName, orientation } = useRadioButtonGroupContext();
  const resolvedIsError = isError || groupIsError;
  const resolvedName = groupName ?? name;

  return (
    <label className={classnames(styles.radioButton, { [styles.horizontal]: orientation === "horizontal" })}>
      <input
        {...rest}
        type="radio"
        value={value}
        name={resolvedName}
        disabled={disabled}
        className={classnames(styles.control, { [styles.invalid]: resolvedIsError })}
      />
      <span className={styles.label}>{label}</span>
    </label>
  );
};
